import store from "@frameworks/web/redux/store";
import { RMS_DETAILS_ERROR_DATA, RMS_DETAILS_HIDE_ERROR_DATA, RMS_HOLDING_DATA, RMS_HOLDING_START_LOADER, RMS_HOLDING_STOP_LOADER, RMS_SUBLIMITS_DATA, RMS_SUBLIMITS_START_LOADER, RMS_SUBLIMITS_STOP_LOADER, } from "../interface/iRmsDetails";
export default class RMSDetailsActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getRmsSublimitsData(rmsSublimits) {
        this.dispatch({
            type: RMS_SUBLIMITS_DATA,
            payload: { rmsSublimits },
        });
    }
    updateRmsHolding(rmsHolding) {
        this.dispatch({
            type: RMS_HOLDING_DATA,
            payload: { rmsHolding },
        });
    }
    startRmsSublimitsLoader() {
        this.dispatch({
            type: RMS_SUBLIMITS_START_LOADER,
        });
    }
    stopRmsSublimitsLoader() {
        this.dispatch({
            type: RMS_SUBLIMITS_STOP_LOADER,
        });
    }
    startRmsHoldingLoader() {
        this.dispatch({
            type: RMS_HOLDING_START_LOADER,
        });
    }
    stopRmsHoldingLoader() {
        this.dispatch({
            type: RMS_HOLDING_STOP_LOADER,
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: RMS_DETAILS_ERROR_DATA,
            payload: { errorData: payload },
            errorType: errorType,
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: RMS_DETAILS_HIDE_ERROR_DATA,
            errorType: errorType,
        });
    }
}
